import React, { memo } from "react";
import PropTypes from "prop-types";

const RepresentativeExample = ({
  amount,
  termLength,
  termType,
  payment,
  totalRepayment,
  formatMoney,
  aprValue,
}) => {
  return (
    <div className="mrc-representative-example">
      <h5 className="title">* Representative example.</h5>
      <p className="main-text">
        Borrowing{" "}
        <span className="dynamic-value amount">{formatMoney(amount)}</span> over{" "}
        <span className="dynamic-value term">{termLength}</span>{" "}
        {termType === "weeks" ? "weeks" : "months"} will cost{" "}
        <span className="dynamic-value payment">{formatMoney(payment)}</span>/
        {termType === "weeks" ? "week" : "month"}. Total amount repayable is{" "}
        <span className="dynamic-value total">
          {formatMoney(totalRepayment)}
        </span>{" "}
        which includes interest at{" "}
        <span className="dynamic-value apr">{aprValue.toFixed(1)}%</span> APR.
      </p>
      <p className="disclaimer">
        The figures given above are for illustrative purposes only and may not
        be the APR you receive. The actual interest rates and repayment amounts
        may vary subject to loan amount and status.
      </p>
    </div>
  );
};

// Add PropTypes for type checking
RepresentativeExample.propTypes = {
  amount: PropTypes.number.isRequired,
  termLength: PropTypes.number.isRequired,
  termType: PropTypes.oneOf(["months", "weeks"]).isRequired,
  payment: PropTypes.number.isRequired,
  totalRepayment: PropTypes.number.isRequired,
  formatMoney: PropTypes.func.isRequired,
  aprValue: PropTypes.number.isRequired,
};

// Use memo to prevent unnecessary re-renders
export default memo(RepresentativeExample);
